import React from "react";
import { useNavigate } from "react-router-dom";

// ── Menu structure ──────────────────────────────────────────────
const MENU_SECTIONS = [
  {
    label: "Overview",
    items: [
      { id: "Dashboard", label: "Dashboard", icon: "🏠" },
    ],
  },
  {
    label: "Requests",
    items: [
      { id: "Report",              label: "Help Requests",    icon: "📋" },
      { id: "SadqaBoxAdmin",       label: "Sadqa Box",        icon: "📦" },
      { id: "MemberAgreementAdmin",label: "Members Agreement", icon: "🤝" },
      { id: "VolunteerAdmin",      label: "Volunteers Agreement", icon: "🙋" },
    ],
  },
  {
    label: "Management",
    items: [
      { id: "Mails",        label: "Contact Mails", icon: "📧" },
      { id: "Verification", label: "Verification",  icon: "✅" },
      { id: "Members",      label: "Members",       icon: "👥" },
      { id: "Volunteers",      label: "Volunteers",       icon: "👥" },
      { id: "Collection",   label: "Collection",    icon: "💰" },
    ],
  },
  {
    label: "Settings",
    items: [
      { id: "Theme", label: "Theme", icon: "🎨" },
    ],
  },
];

const AdminSideBar = ({ activeMenu, onSelect }) => {
  const navigate = useNavigate();

  return (
    <>
      {/* Brand */}
      <div className="ad-sidebar-brand">
        <div className="ad-brand-mark">﷽</div>
        <div className="ad-brand-text">
          <span className="ad-brand-name">Al-Qaim Welfare</span>
          <span className="ad-brand-sub">Admin Dashboard</span>
        </div>
      </div>

      {/* Nav */}
      <nav className="ad-sidebar-nav">
        {MENU_SECTIONS.map((section, si) => (
          <div key={si}>
            <div className="ad-nav-section-label">{section.label}</div>
            {section.items.map(({ id, label, icon }) => (
              <button
                key={id}
                className={`ad-nav-btn ${activeMenu === id ? "active" : ""}`}
                onClick={() => onSelect(id)}
              >
                <span className="ad-nav-icon">{icon}</span>
                <span className="ad-nav-label">{label}</span>
              </button>
            ))}
            {si < MENU_SECTIONS.length - 1 && <div className="ad-nav-divider" />}
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div className="ad-sidebar-footer">
        <button
          className="ad-back-btn"
          onClick={() => {
            sessionStorage.removeItem("token");
            navigate("/");
          }}
        >
          <i className="fa fa-arrow-left" style={{ fontSize: "0.8rem" }}></i>
          <span>Back to Website</span>
        </button>
      </div>
    </>
  );
};

export default AdminSideBar;